import { Box, styled, TableCell, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const Wrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
    height: 'auto',
    width: '100%',
    gap: '24px',
    backgroundColor: palette.background.general,

    [theme.breakpoints.down('tablet')]: {
      padding: 0,
      backgroundColor: palette.white,
      gap: '0px',
    },
  };
});

export const MainContentWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '80%',
    position: 'relative',
    paddingBottom: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    background: '#fff',
    minHeight: 'calc(100vh - 198px)',
    borderRadius: '24px',
    padding: '32px',
    marginBottom: '24px',

    [theme.breakpoints.down('desktop')]: {
      width: '95%',
    },

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      padding: '32px 16px 32px 16px',
      gap: '32px',
      marginBottom: '0',
    },
  };
});

export const TabsContainer = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '80%',
    minHeight: '30px',
    display: 'flex',
    gap: '8px',

    [theme.breakpoints.down('desktop')]: {
      width: '95%',
    },

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      padding: '16px 16px 0 16px',
    },
  };
});

export const TabItem = styled(Box)<{ selected: any }>(({ theme, selected }) => {
  return {
    padding: ' 12px 16px',
    border: '1px solid',
    backgroundColor: selected ? palette.text.header : palette.white,
    borderColor: selected ? 'transparent' : '#D8DBE8',
    borderRadius: '32px',
    cursor: selected ? 'not-allowed' : 'pointer',
    pointerEvents: selected ? 'none' : 'initial',

    '> p': {
      color: selected ? palette.white : palette.text.header,
    },
  };
});

export const CandidatesListBlockMainWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginBottom: '24px',
    overflow: 'auto',
  };
});

export const CustomTableCellHeading = styled(TableCell)(({ theme }: { theme: Theme }) => {
  return {
    color: '#857F8B',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '128%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
}) as typeof TableCell;

export const CustomTableCellJobPost = styled(TableCell)(({ theme }: { theme: Theme }) => {
  return {
    color: '#444444',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '128%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
}) as typeof TableCell;

export const CustomTableCell = styled(TableCell)(({ theme }: { theme: Theme }) => {
  return {
    color: '#444444',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '136%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
}) as typeof TableCell;

export const NewApplicantsSpan = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    backgroundColor: '#F3F9EE',
    color: '#85C553',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '128%',
    padding: '4px 8px',
    borderRadius: '8px',
    marginRight: '8px',
  };
}) as typeof Typography;

export const ApplicantsSpan = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: '#663497',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '128%',
    padding: '4px 8px',

    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  };
}) as typeof Typography;

export const ApplicantsListBlockTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '120%',
  };
});
